import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const ROUTES = {
  TEAM_ROLE_LIST: 'team-role',
  TEAM_ROLE_CREATE: 'team-role-create',
  TEAM_ROLE_DETAIL: 'team-role-detail'
}

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const routes = [
  {
    path: 'team-roles/',
    name: ROUTES.TEAM_ROLE_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['account_user_list'],
      requiresAuth: true
    },
    component: () => import('./TeamRoleList.vue')
  }

]

export { routes, ROUTES }
